<template>
    <div id="main">
        <loader v-if="isLoading" />
        <div class="page page-container">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("dependencias") }}
                        </h1>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            @click="onFecharModal"    
                        >
                            {{ $t("voltar") }}
                        </button>
                    </div>
                </div>
                <h3 v-html="$t('msg-aviso-dependencias')">

                </h3>
                <br>
                <div>
                    <ul>
                        <li v-for="(dep, i) in dependencias" :key="i">
                                <b>{{ $t(dep)}}</b>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        dependencias: {
            type: Array,
            default: () => []
        },
    },
    data() {
        return {
            isLoading: false,
            msgs: [],
            isSaving: false,
            isUpdate: false,
            situacao: { label: "ativo", id: 1 }
        };
    },
    created() {
    },
    computed: {
        ...mapState(['hide']),
    },
    methods: {
        onFecharModal(){
            this.$emit('fecharModal',true);
        }
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
    #color {
        padding: 0 !important;
        height: 36px;
        cursor: pointer;
    }
}
</style>
